/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState, useContext, useEffect, ChangeEvent } from 'react';
import { Link, Redirect, useHistory } from 'react-router-dom';
import { GlobalContext } from '../../providers/GlobalProvider';
import TableRows from './TableRow';
import Pagination from '@mui/material/Pagination';
interface ISingleSearch {
    searchedString?: string;
    SubmitValue?: () => void;
    AddSearch?: () => void;
    ReturnBack?: () => void;
    handleOpenModal?: () => void;
    handleOpenCreateModal?: () => void;
}

const GroupSearch: React.FC<ISingleSearch> = ({ searchedString, SubmitValue, AddSearch, ReturnBack, handleOpenModal, handleOpenCreateModal }) => {
  const { cur_user } = useContext(GlobalContext);
  const [ stepsRow, setStepsRow ] = useState<number>(1);
  //   const [ searchedString, setSearchedString ] = useState<string>('');
  const [ inputString, setInputString ] = useState<string>('');

  const items = [
    { id: 1, name: 'T-Shirt' },
    { id: 2, name: 'Jeans' },
    { id: 3, name: 'Sneakers' },
    { id: 4, name: 'Jacket' },
    { id: 5, name: 'Sweater' },
    { id: 6, name: 'Cap' },
    { id: 7, name: 'Socks' },
    { id: 8, name: 'Shorts' },
    { id: 9, name: 'Backpack' },
    { id: 10, name: 'Gloves' }
  ];


  if (!cur_user.selected_team) {
    return <Redirect to='/' />;
  }

  const handleSearchChange = (e: any) => {
    const { value } = e.target;
    setInputString(value);
  };
  const [ currentItems, setCurrentItems ] = useState<any[]>([]);
  const [ currentPage, setCurrentPage ] = useState(1);
  const [ totalPages, setTotalPages ] = useState(1);
  const itemsPerPage = 7;

  useEffect(() => {
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    if (items.length > 0) {
      setCurrentItems(items.slice(indexOfFirstItem, indexOfLastItem));
      setTotalPages(Math.ceil(items.length / itemsPerPage));
    } else {
      setTotalPages(1);
    }
  }, [ currentPage, itemsPerPage ]);

  const handlePageChange = (e: ChangeEvent<unknown>, new_page: number) => {
    setCurrentPage(new_page);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    setCurrentItems(items.slice(indexOfFirstItem, indexOfLastItem));
  };

  return (
    <>
      {
        searchedString === '' && (
          <>
            <div className='activity-cont-frame'>
              <div className='activity-cont-frame-left' style={{ gap: '5px' }}>
                <div className='audit-modal-cont-head'>
                  <div className='group-search-header'>
                    <div className='group-search-header-text'>
                      Searches
                    </div>
                    <div className='group-search-badge'>
                      <p>0 total</p>
                    </div>
                    <div className='group-search-action-btn' onClick={handleOpenCreateModal}>
                      <div className='group-search-action-btn-text'>
                        Save all as ticket
                      </div>
                    </div>
                  </div>
                </div>
                <div className='view-history-head-frame'>
                  <div className='view-history-head-frame-cell'>
                    <div className='view-history-head-frame-cell-cont'>
                      <div className='view-history-head-frame-cell-cont-text'>
                        Name
                      </div>
                      <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
                        <path d='M8.00016 12.6663V3.33301M8.00016 3.33301L3.3335 7.99967M8.00016 3.33301L12.6668 7.99967' stroke='#F5FAFF' strokeWidth='1.33333' strokeLinecap='round' strokeLinejoin='round' />
                      </svg>
                    </div>
                  </div>
                  <div className='view-history-head-frame-cell'>
                    <div className='view-history-head-frame-cell-cont'>
                      <div className='view-history-head-frame-cell-cont-text'>

                      </div>

                    </div>
                  </div>
                  <div className='view-history-head-frame-cell'>
                    <div className='view-history-head-frame-cell-cont'>
                      <div className='view-history-head-frame-cell-cont-text'>

                      </div>

                    </div>
                  </div>
                  <div className='view-history-head-frame-cell-empty'></div>
                </div>
                <div className='view-history-body-frame' style={{ maxHeight: '144px', height: '144px' }}>
                  {currentItems.map((row: any, index: number) => (
                    <TableRows key={index} name={row.name} handleOpenModal={handleOpenModal}/>
                  ))}
                </div>
                <div className='monitor-results-footer'>
                  <div className='screening-results-pagination-text'>
                     Page {currentPage} of {totalPages}
                  </div>
                  <div className='screening-results-footer-action-group'>
                    <div className='hb-pagination'>
                      <Pagination
                        onChange={handlePageChange}
                        size='large'
                        count={totalPages}
                        shape='rounded'
                        variant='text'
                        page={currentPage}
                      />
                    </div>
                  </div>
                </div>
              </div>

            </div>
            <div className='classify-footer'>
              <div className='classify-footer-btn' onClick={AddSearch}>
                <div className='classify-footer-btn-div'>
                                  + Add New Search
                </div>
              </div>
            </div>
          </>
        )
      }
      {
        searchedString === 'Add Search' && (
          <div className='classify'>
            <div className='classify-header'>
                Item / Product Name
            </div>
            <div className='classify-cont'>
              <div className='classify-cont-sec'>
                <div className='classify-cont-sec-div'>
                  <input placeholder='Enter your product name or keywords' className='classify-cont-sec-input' onChange={(e) => handleSearchChange(e)}/>
                </div>
              </div>
            </div>
            <div className='classify-footer'>
              <div className='classify-footer-btn' onClick={SubmitValue}>
                <div className='classify-footer-btn-div'>
                    Submit
                </div>
              </div>
              <div className='classify-footer-txt' style={{ flex: '1 0 0' }}>
                    or press Enter
              </div>
              <div className='classify-footer-txt-return' onClick={ReturnBack}>
                <svg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 18 18' fill='none'>
                  <path d='M14.25 9H3.75M3.75 9L9 14.25M3.75 9L9 3.75' stroke='#BDBEC1' strokeWidth='1.66667' strokeLinecap='round' strokeLinejoin='round'/>
                </svg>
                Return to table
              </div>
            </div>
          </div>
        )
      }
      {
        searchedString === 'T-Shirt' && (
          (
            <div className='classify'>
              <div className='classify-header'>
                Item / Product Name
              </div>
              <div className='classify-cont'>
                <div className='classify-cont-sec'>
                  <div className='classify-cont-sec-div'>
                    <input placeholder='T-Shirt' className='classify-cont-sec-input' onChange={(e) => handleSearchChange(e)}/>
                  </div>
                </div>
              </div>
              <div className='classify-footer'>
                <div className='classify-footer-btn-loading'>
                  <div className='classify-footer-btn-div'>
                    Loading...
                  </div>
                </div>
                <div className='classify-footer-txt'>
                or press Enter
                </div>
              </div>
            </div>
          )
        )
      }
      {
        searchedString === 'Found T-Shirt' && (
          (
            <div className='classify'>
              <div className='classify-found'>
                <div className='classify-header'>
                Item / Product Name
                </div>
                <div className='classify-cont'>
                  <div className='classify-cont-sec'>
                    <div className='classify-cont-sec-div'>
                      <div className='classify-cont-sec-input'>
                        {'T-Shirt'}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className='classify-follow-up'>
                Generated Follow-Up Questions
              </div>

              <div className='classify-body'>
                <div className='classify-header'>
                What material is the T-shirt made of?
                </div>
                <div className='classify-cont'>
                  <div className='classify-cont-sec'>
                    <div className='classify-cont-sec-div'>
                      <input placeholder='Enter details' className='classify-cont-sec-input' onChange={(e) => handleSearchChange(e)}/>
                    </div>
                  </div>
                </div>
                <div className='classify-header'>
                Is the T-shirt intended for men, boys, or another gender?
                </div>
                <div className='classify-cont'>
                  <div className='classify-cont-sec'>
                    <div className='classify-cont-sec-div'>
                      <input placeholder='Enter details' className='classify-cont-sec-input' onChange={(e) => handleSearchChange(e)}/>
                    </div>
                  </div>
                </div>
                <div className='classify-header'>
                Does the T-shirt have any specific features like being all white or having a mitered V-neck?
                </div>
                <div className='classify-cont'>
                  <div className='classify-cont-sec'>
                    <div className='classify-cont-sec-div'>
                      <input placeholder='Enter details' className='classify-cont-sec-input' onChange={(e) => handleSearchChange(e)}/>
                    </div>
                  </div>
                </div>
              </div>

              <div className='classify-footer'>
                <div className='classify-footer-btn' onClick={SubmitValue}>
                  <div className='classify-footer-btn-div'>
                    Submit
                  </div>
                </div>
                <div className='classify-footer-txt'>
                or press Enter
                </div>
              </div>
            </div>
          )
        )
      }

      {
        searchedString === 'Found T-Shirts' && (
          <>
            <div className='activity-cont-frame'>
              <div className='activity-cont-frame-left'>
                <div className='audit-modal-cont-head'>
                  <div className='group-search-header'>
                    <div className='group-search-header-text'>
                                      Searches
                    </div>
                    <div className='group-search-badge'>
                      <p>0 total</p>
                    </div>
                    <div className='group-search-action-btn'>
                      <div className='group-search-action-btn-text'>
                                          Save all as ticket
                      </div>
                    </div>
                  </div>
                </div>
                <div className='view-history-head-frame'>
                  <div className='view-history-head-frame-cell'>
                    <div className='view-history-head-frame-cell-cont'>
                      <div className='view-history-head-frame-cell-cont-text'>
                                          Name
                      </div>
                      <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
                        <path d='M8.00016 12.6663V3.33301M8.00016 3.33301L3.3335 7.99967M8.00016 3.33301L12.6668 7.99967' stroke='#F5FAFF' strokeWidth='1.33333' strokeLinecap='round' strokeLinejoin='round' />
                      </svg>
                    </div>
                  </div>
                  <div className='view-history-head-frame-cell'>
                    <div className='view-history-head-frame-cell-cont'>
                      <div className='view-history-head-frame-cell-cont-text'>

                      </div>

                    </div>
                  </div>
                  <div className='view-history-head-frame-cell'>
                    <div className='view-history-head-frame-cell-cont'>
                      <div className='view-history-head-frame-cell-cont-text'>

                      </div>

                    </div>
                  </div>
                  <div className='view-history-head-frame-cell-empty'></div>
                </div>
                <div className='view-history-body-frame' style={{ maxHeight: '144px', height: '144px' }}>
                  {currentItems.map((row: any, index: number) => (
                    <TableRows key={index} name={row.name} handleOpenModal={handleOpenModal}/>
                  ))}
                </div>
                <div className='monitor-results-footer'>
                  <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' cursor={'pointer'}>
                    <path d='M14.8303 16.9997C15.0166 16.8123 15.1211 16.5589 15.1211 16.2947C15.1211 16.0305 15.0166 15.7771 14.8303 15.5897L11.2903 11.9997L14.8303 8.4597C15.0166 8.27234 15.1211 8.01889 15.1211 7.7547C15.1211 7.49052 15.0166 7.23707 14.8303 7.0497C14.7373 6.95598 14.6267 6.88158 14.5049 6.83081C14.383 6.78004 14.2523 6.75391 14.1203 6.75391C13.9883 6.75391 13.8576 6.78004 13.7357 6.83081C13.6139 6.88158 13.5033 6.95598 13.4103 7.0497L9.1703 11.2897C9.07657 11.3827 9.00218 11.4933 8.95141 11.6151C8.90064 11.737 8.8745 11.8677 8.8745 11.9997C8.8745 12.1317 8.90064 12.2624 8.95141 12.3843C9.00218 12.5061 9.07657 12.6167 9.1703 12.7097L13.4103 16.9997C13.5033 17.0934 13.6139 17.1678 13.7357 17.2186C13.8576 17.2694 13.9883 17.2955 14.1203 17.2955C14.2523 17.2955 14.383 17.2694 14.5049 17.2186C14.6267 17.1678 14.7373 17.0934 14.8303 16.9997Z' fill='#BDBEC1' />
                  </svg>
                  <select className='monitor-results-footer-input'>
                    <option className='monitor-results-footer-input-opt' defaultChecked>1</option>
                  </select>
                  <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' cursor={'pointer'}>
                    <path d='M9.1697 7.0003C8.98345 7.18766 8.87891 7.44111 8.87891 7.7053C8.87891 7.96948 8.98345 8.22293 9.1697 8.4103L12.7097 12.0003L9.1697 15.5403C8.98345 15.7277 8.87891 15.9811 8.87891 16.2453C8.87891 16.5095 8.98345 16.7629 9.1697 16.9503C9.26266 17.044 9.37326 17.1184 9.49512 17.1692C9.61698 17.22 9.74769 17.2461 9.8797 17.2461C10.0117 17.2461 10.1424 17.22 10.2643 17.1692C10.3861 17.1184 10.4967 17.044 10.5897 16.9503L14.8297 12.7103C14.9234 12.6173 14.9978 12.5067 15.0486 12.3849C15.0994 12.263 15.1255 12.1323 15.1255 12.0003C15.1255 11.8683 15.0994 11.7376 15.0486 11.6157C14.9978 11.4939 14.9234 11.3833 14.8297 11.2903L10.5897 7.0003C10.4967 6.90657 10.3861 6.83217 10.2643 6.7814C10.1424 6.73064 10.0117 6.7045 9.8797 6.7045C9.74769 6.7045 9.61698 6.73064 9.49512 6.7814C9.37326 6.83217 9.26266 6.90657 9.1697 7.0003Z' fill='#BDBEC1' />
                  </svg>
                  <div className='monitor-results-footer-right'>
                    <div className='monitor-results-footer-right-text'>1-25</div>
                    <div className='monitor-results-footer-right-text'>of 4</div>
                  </div>
                </div>
              </div>

            </div>
            <div className='classify-footer'>
              <div className='classify-footer-btn' onClick={AddSearch}>
                <div className='classify-footer-btn-div'>
                                  + Add New Search
                </div>
              </div>
            </div>
          </>
        )
      }

    </>

  );
};

export default GroupSearch;
